import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { TOAST_DURATION, TOAST_POSITION } from "../../common/app_constant";
import { SUB_DIRECTORY } from "../../common/constant";
import { actionSubscribeNewsletter, resetSubNewsletterResponse } from "../../common/store";
import ErrorLabel from "../error_label";
import { useNavigate } from 'react-router-dom';

const Newsletter = () => {

    const dispatch = useDispatch()

    const navigation = useNavigate()

    const { subNewsLetter } = useSelector((state) => ({
        ...state.commonStore
    }))

    const {
        register,
        watch,
        formState: { errors },
        getValues,
        handleSubmit,
        setValue,
        reset
    } = useForm({
        defaultValues: {
        },
    });

    useEffect(() => {
        if (subNewsLetter !== null) {
            dispatch(resetSubNewsletterResponse())
            if (subNewsLetter.result === true) {
                toast.success(subNewsLetter.message, {
                    duration: TOAST_DURATION,
                    position: TOAST_POSITION
                })
                reset()
            } else {
                switch (subNewsLetter.status_code) {
                    // case 400:
                    //     toast.error(subNewsLetter.message, {
                    //         duration: TOAST_DURATION,
                    //         position: TOAST_POSITION,
                    //         style: {
                    //             color: TOAST_ERROR_COLOR
                    //         }
                    //     })
                    //     localStorage.clear()
                    //     logout()
                    //     navigation("/login", { replace: true });
                    //     break;
                    case 401:
                        localStorage.clear()
                        navigation("/login", { replace: true });
                        break;
                    default:
                }
            }
        }
    }, [subNewsLetter])


    const onSubmit = async (data) => {
        dispatch(actionSubscribeNewsletter({
            email: data.email

        }))

    };

    return (
        <>
            <div className="mt-3">
                <span className="fw-bold">Newsletter</span>
                <div className="card shadow mt-2">
                    <div className="card-body text-center">
                        <img src={`${SUB_DIRECTORY}/assets/images/newsletter.png`}
                            className="w-75" alt="" />
                        <h6 className="mt-2 mb-0 text-secondary">Subscribe To</h6>
                        <h4>Our Newsletter</h4>
                        <p className="text-secondary fs-7">
                            Subscribe to our newsletter and stay updated
                        </p>
                        <form
                            noValidate
                            autoComplete="off"
                            onSubmit={handleSubmit(
                                onSubmit
                            )}
                        >
                            <div className="input-group mb-3">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Your Email"
                                    {...register(
                                        "email",
                                        {
                                            required: "This is required.",
                                            pattern: {
                                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                                                message: "Enter valid Email Id.",
                                            },
                                        }
                                    )}
                                />
                                <button
                                    className="btn btn-outline-secondary"
                                    type="submit"
                                    id="button-addon2"
                                >
                                    Submit
                                </button>
                            </div>
                            {errors.email && (
                                <ErrorLabel
                                    message={
                                        errors
                                            .email
                                            ?.message
                                    }
                                />
                            )}
                        </form>
                    </div>
                </div>
            </div>

        </>
    )
}

export default Newsletter;